import { FC } from "react";
import { useTranslation } from "react-i18next";

export interface Column {
  name: string;
  minWidth?: number;
}

interface TableHeaderProps {
  columns: Column[];
}

const TableHeader: FC<TableHeaderProps> = ({ columns }: TableHeaderProps) => {
  const { t } = useTranslation();

  return (
    <thead>
      <tr>
        {columns.map((column, index) => (
          <th
            key={column.name || `col-${index}`}
            style={{ minWidth: column.minWidth }}
            className={`py-5 text-left ${index === 0 ? "" : "border-0 border-b border-solid border-gray-200"}`}
            scope="col"
          >
            <span className="text-base font-medium">
              {column.name ? t(column.name) : ""}
            </span>
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default TableHeader;
